
export const CREATE_PARTNER_MUTATION = `
  mutation CreatePartner($object: partners_insert_input!) {
    insert_partners_one(object: $object) {
      id
      partner_name
      partner_description
      partner_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const UPDATE_PARTNER_MUTATION = `
  mutation UpdatePartner($id: Int!, $set: partners_set_input!) {
    update_partners_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      partner_name
      partner_description
      partner_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_PARTNER_MUTATION = `
  mutation DeletePartner($id: Int!) {
    delete_partners_by_pk(id: $id) {
      id
      partner_name
    }
  }
`; 